module.exports = __webpack_public_path__ + "img/male-avatar.3ebb237.png";